module.exports = __webpack_public_path__ + "static/media/icons.2ecfc31d.png";